import axios from "axios";
import qs from "qs";
import Raven from "raven-js";
import { StatusCodes } from "../constants/HttpStatusCodes";

let authed = true;
class ApiHelper {
  static uri(path: string) {
    const apiEndpoint = process.env.REACT_APP_ADMIN_API_HOST;
    return apiEndpoint + path;
  }

  static headers() {
    const { state } = JSON.parse(sessionStorage.getItem("_auth") || "");
    let header;

    if (state && state.token) {
      header = {
        "content-type": "application/json",
        accept: "application/json",
        authorization: "Bearer " + state.token,
      };
    }

    return header;
  }

  static async request(resources: string, params?: any, opts: any = {}) {
    // If the user refresh token is expired, headers will be undefined.
    let headers = opts.headers ? opts.headers : ApiHelper.headers();
    let endpoint = ApiHelper.uri(resources);

    let options = Object.assign(
      {},
      {
        url: endpoint,
        headers,
      },
      opts
    );

    return axios(endpoint, options)
      .then(ApiHelper.handleResponse)
      .catch((e: any) => {
        if (e.response.status === StatusCodes.UNAUTHORIZED && authed) {
          authed = false;
          const {
            state: {
              profile: { id },
            },
          } = JSON.parse(sessionStorage.getItem("_auth") || "{}");
          if (id) {
            alert("Your session has ended, please relogin.");
            sessionStorage.setItem(
              "resume",
              window.location.pathname + window.location.search
            );
          }
          sessionStorage.removeItem("_auth");
          window.location.replace(window.location.origin);
        }
        throw ApiHelper.handleError(e);
      });
  }

  static get(resources: string, params?: any, opts = {}) {
    opts = Object.assign({}, opts, {
      method: "GET",
      data: null,
    });

    resources = !params ? resources : resources + "?" + qs.stringify(params);
    return ApiHelper.request(resources, null, opts);
  }

  static post(resources: string, params?: any, opts = {}) {
    opts = Object.assign({}, opts, {
      data: ApiHelper.serialize(params),
      method: "POST",
    });

    return ApiHelper.request(resources, params, opts);
  }

  static formidable(resource: string, request: any, opts: any = {}) {
    let headers: any = ApiHelper.headers();
    delete headers["content-type"];
    delete headers["accept"];

    opts = {
      headers: { ...headers, "content-type": "multipart/form-data" },
      method: opts.method,
      data: request,
    };

    return ApiHelper.request(resource, request, opts);
  }

  static put(resources: string, params: any, opts = {}) {
    opts = Object.assign({}, opts, {
      data: ApiHelper.serialize(params),
      method: "PUT",
    });

    return ApiHelper.request(resources, params, opts);
  }

  static delete(resources: string, params?: any, opts = {}) {
    opts = Object.assign({}, opts, {
      data: ApiHelper.serialize(params),
      method: "DELETE",
    });

    return ApiHelper.request(resources, params, opts);
  }

  static serialize(params: any) {
    return JSON.stringify(params);
  }

  static handleResponse(response: any) {
    const { status, data } = response;

    if (status < 200 && status > 300) {
      throw this.handleError(response);
    }

    return data;
  }

  static handleError(error: any) {
    const errs = error && error.response ? error.response.data : error;
    Raven.captureException(new Error(errs), {
      tags: {
        error_type: "API Failed",
        error_url: error.request.responseURL + ":" + error.request.status,
      },
    });
    return errs;
  }
}

export default ApiHelper;
